import { render, staticRenderFns } from "./AddSVG.vue?vue&type=template&id=73f8d768&"
import script from "./AddSVG.vue?vue&type=script&lang=js&"
export * from "./AddSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports